import { render, staticRenderFns } from "./HandleProjectStatus.vue?vue&type=template&id=f1ae7290"
import script from "./HandleProjectStatus.vue?vue&type=script&lang=js"
export * from "./HandleProjectStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports